module.exports = __webpack_public_path__ + "img/4.252834dd.svg";